// @flow
export const getShowToJoinOffset = (state: Object): number => state.leagues.show_to_join.offset;

export default getShowToJoinOffset;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getShowToJoinOffset.js